module.exports = __webpack_public_path__ + "img/CHS.614b781c.jpg";